var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.type === "edit" ? "编辑" : "新增",
        visible: _vm.dialog,
        width: _vm.getIsMobile ? "100%" : "60%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "custom-form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "right",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "型号", prop: "xhname" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入型号" },
                model: {
                  value: _vm.form.xhname,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "xhname", $$v)
                  },
                  expression: "form.xhname",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "品牌", prop: "source" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入品牌" },
                model: {
                  value: _vm.form.source,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "source", $$v)
                  },
                  expression: "form.source",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "产地", prop: "address" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入产地" },
                model: {
                  value: _vm.form.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "address", $$v)
                  },
                  expression: "form.address",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "包装", prop: "baozhuang" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入包装" },
                model: {
                  value: _vm.form.baozhuang,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "baozhuang", $$v)
                  },
                  expression: "form.baozhuang",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "beizhu" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入备注" },
                model: {
                  value: _vm.form.beizhu,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "beizhu", $$v)
                  },
                  expression: "form.beizhu",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "供应商", prop: "gongyingshang" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入供应商" },
                model: {
                  value: _vm.form.gongyingshang,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "gongyingshang", $$v)
                  },
                  expression: "form.gongyingshang",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "库存数量", prop: "number" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入库存数量" },
                model: {
                  value: _vm.form.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "number", _vm._n($$v))
                  },
                  expression: "form.number",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "未税价格", prop: "wshui" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入未税价格" },
                model: {
                  value: _vm.form.wshui,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "wshui", _vm._n($$v))
                  },
                  expression: "form.wshui",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "含税价格", prop: "hshui" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入含税价格" },
                model: {
                  value: _vm.form.hshui,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "hshui", _vm._n($$v))
                  },
                  expression: "form.hshui",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "库房货位", prop: "kufang" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入库房货位" },
                model: {
                  value: _vm.form.kufang,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "kufang", $$v)
                  },
                  expression: "form.kufang",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "自定义价格", prop: "zdyprice" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入自定义价格" },
                model: {
                  value: _vm.form.zdyprice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "zdyprice", _vm._n($$v))
                  },
                  expression: "form.zdyprice",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "收票发票号", prop: "spfph" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入收票发票号" },
                model: {
                  value: _vm.form.spfph,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "spfph", $$v)
                  },
                  expression: "form.spfph",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "进货日期", prop: "settime" } },
            [
              _c("el-date-picker", {
                staticClass: "custom-date-picker",
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "选择日期",
                },
                model: {
                  value: _vm.form.settime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "settime", $$v)
                  },
                  expression: "form.settime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "收票状态", prop: "spzt" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.spzt,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "spzt", $$v)
                    },
                    expression: "form.spzt",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("未税")]),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("已到")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("未到")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "商品名称", prop: "title" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "title", $$v)
                    },
                    expression: "form.title",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "配件" } }, [
                    _vm._v("配件"),
                  ]),
                  _c("el-radio", { attrs: { label: "密封件" } }, [
                    _vm._v("密封件"),
                  ]),
                  _c("el-radio", { attrs: { label: "丝杆螺母" } }, [
                    _vm._v("丝杆螺母"),
                  ]),
                  _c("el-radio", { attrs: { label: "导轨滑块" } }, [
                    _vm._v("导轨滑块"),
                  ]),
                  _c("el-radio", { attrs: { label: "油脂" } }, [
                    _vm._v("油脂"),
                  ]),
                  _c("el-radio", { attrs: { label: "轴承" } }, [
                    _vm._v("轴承"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "合同状态", prop: "zt" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.zt,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "zt", $$v)
                    },
                    expression: "form.zt",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开放")]),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("锁定")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleReset } }, [
            _vm._v("重 置"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }